const features = [
  {
    icon: 'bolt',
    title: 'Instant Subdomains',
    description: 'Get your site live in seconds with a vanity subdomain on wiserwebhost.com.',
  },
  {
    icon: 'cloud_download',
    title: 'Import Any Site',
    description: 'Proxy existing sites instantly or crawl and migrate content with one click.',
  },
  {
    icon: 'lock',
    title: 'Free HTTPS',
    description: 'Automatic TLS certificates for both subdomains and custom domains.',
  },
  {
    icon: 'domain',
    title: 'Custom Domains',
    description: 'Add your own domain with DNS verification and automatic certificate provisioning.',
  },
  {
    icon: 'speed',
    title: 'Edge Caching',
    description: 'Built-in caching and gzip compression for blazing-fast page loads.',
  },
  {
    icon: 'tune',
    title: 'Full Control',
    description: 'Configure caching, compression, HTTPS, and more from your dashboard.',
  },
];

export default function HostingGetStartedPage() {
  const dashboardUrl = 'https://dashboard.wiserwebcloud.com/hosting?wizard=true';

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      {/* Hero */}
      <section className="relative overflow-hidden py-24 lg:py-32">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-amber-500/5" />
        <div className="relative max-w-5xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-500/10 border border-orange-500/20 rounded-full text-sm text-orange-400 mb-6">
            <span className="material-icons text-sm">public</span>
            WiserWebHost
          </div>
          <h1 className="text-4xl lg:text-6xl font-bold tracking-tight mb-6">
            Host your site.
            <br />
            <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
              Simple. Fast. Free TLS.
            </span>
          </h1>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto mb-10">
            Create new sites or import existing ones. Every site gets a subdomain
            on wiserwebhost.com with automatic HTTPS. Add your custom domain when ready.
          </p>
          <div className="flex items-center justify-center gap-4">
            <a
              href={dashboardUrl}
              className="px-8 py-3 bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-500 hover:to-amber-500 rounded-xl text-base font-semibold shadow-lg shadow-orange-500/20 transition-all"
            >
              Get Started Free
            </a>
            <a
              href="#features"
              className="px-6 py-3 border border-zinc-700 hover:border-zinc-500 rounded-xl text-base text-zinc-300 transition-colors"
            >
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section id="features" className="py-20 max-w-5xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-center mb-12">Everything you need to host</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="p-6 bg-zinc-900 border border-zinc-800 rounded-xl hover:border-zinc-700 transition-colors">
              <span className="material-icons text-2xl text-orange-400 mb-3 block">{f.icon}</span>
              <h3 className="text-base font-semibold text-zinc-200 mb-2">{f.title}</h3>
              <p className="text-sm text-zinc-500">{f.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-4">Ready to host?</h2>
          <p className="text-zinc-400 mb-8">
            Sign up for WiserWebCloud and create your first hosted site in under a minute.
          </p>
          <a
            href={dashboardUrl}
            className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-500 hover:to-amber-500 rounded-xl text-base font-semibold shadow-lg shadow-orange-500/20 transition-all"
          >
            <span className="material-icons">rocket_launch</span>
            Create Your First Site
          </a>
        </div>
      </section>
    </div>
  );
}
